import React, { useEffect } from 'react';
import './style.css';

const apkUrl = process.env.REACT_APP_ANDROID_APK_URL || 'https://img.igifthouse.com/download/yongzhixuan-v1.0.0.apk';
const companyName = process.env.REACT_APP_COMPANY_NAME || '深圳市礼屋科技有限公司';
const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || '944195790@qq.com';
const appVersion = process.env.REACT_APP_ANDROID_VERSION || 'V1.0.0';
const icpNumber = '粤ICP备2025487488号';

function Download() {
  useEffect(() => {
    document.title = '佣值选 - Android 官方下载';
  }, []);

  return (
    <main className="download-page">
      <section className="download-hero-band">
        <header className="download-nav">
          <a className="download-brand" href="/" aria-label="佣值选官网首页">
            <span className="download-brand__icon">佣</span>
            <span>佣值选</span>
          </a>
          <nav aria-label="官网导航">
            <a href="#features">功能亮点</a>
            <a href="#install">安装说明</a>
            <a href="/privacy">隐私政策</a>
          </nav>
        </header>

        <div className="download-hero">
          <section className="download-hero__copy">
            <div className="download-badge">Android 首发测试版</div>
            <h1>佣值选</h1>
            <p className="download-hero__subtitle">
              购物前先查券、比价、看返利，让每一次消费都更有价值。
            </p>
            <div className="download-actions">
              <a className="download-primary-button" href={apkUrl}>
                下载 Android 版
              </a>
              <a className="download-secondary-button" href="/privacy">
                查看隐私政策
              </a>
            </div>
            <p className="download-note">
              当前版本 {appVersion} · Android 7.0 及以上 · 官方域名下载
            </p>
          </section>

          <section className="download-hero__visual" aria-label="佣值选 App 功能预览">
            <div className="download-phone-card">
              <div className="download-phone-card__screen">
                <div className="download-phone-status">
                  <span>9:41</span>
                  <span>5G ▰</span>
                </div>
                <div className="download-phone-top">
                  <div className="download-app-logo">佣</div>
                  <span>高佣精选</span>
                </div>
                <h2>先查优惠<br />再下单</h2>
                <div className="download-search-preview">搜索商品 / 粘贴口令查券</div>
                <div className="download-rebate-card">
                  <span>预计可省</span>
                  <strong>¥38.60</strong>
                </div>
                <div className="download-feature-list">
                  <div>
                    <b>券后低价</b>
                    <small>优惠券自动展示</small>
                    <em>省钱</em>
                  </div>
                  <div>
                    <b>返利追踪</b>
                    <small>待结算到可提现</small>
                    <em>清晰</em>
                  </div>
                  <div>
                    <b>安全合规</b>
                    <small>服务端处理密钥</small>
                    <em>放心</em>
                  </div>
                </div>
                <div className="download-tabbar">
                  <span>首页</span>
                  <span>选品</span>
                  <span>消息</span>
                  <span>我的</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <section id="features" className="download-content-band">
        <div className="download-feature-grid">
          <article>
            <span>1</span>
            <h3>先查优惠再下单</h3>
            <p>聚合商品优惠、券后价和返利信息，帮助用户在跳转第三方平台前做出选择。</p>
          </article>
          <article>
            <span>2</span>
            <h3>返利状态可追踪</h3>
            <p>从预估返利、待结算到可提现，状态清晰展示，减少用户对返利进度的困惑。</p>
          </article>
          <article>
            <span>3</span>
            <h3>安全合规优先</h3>
            <p>平台密钥、订单同步、返利计算都由服务端处理，客户端只负责展示和跳转。</p>
          </article>
        </div>
      </section>

      <section id="install" className="download-info-panel">
        <div>
          <span>下载与安装</span>
          <h2>请通过官方域名安装佣值选 Android 客户端</h2>
          <p>
            安装测试版 APK 时，系统可能提示“未知来源应用”。请确认下载地址为官方域名后再继续安装。
          </p>
        </div>
        <dl>
          <div>
            <dt>软件名称</dt>
            <dd>佣值选 Android 客户端软件</dd>
          </div>
          <div>
            <dt>当前版本</dt>
            <dd>{appVersion}</dd>
          </div>
          <div>
            <dt>运行环境</dt>
            <dd>Android 7.0 及以上</dd>
          </div>
          <div>
            <dt>开发主体</dt>
            <dd>{companyName}</dd>
          </div>
        </dl>
      </section>

      <section id="agreement" className="download-legal">
        <h2>用户协议摘要</h2>
        <p>
          佣值选主要提供商品浏览、优惠信息展示、第三方平台跳转、返利记录查询、钱包余额查看、
          提现申请和账户管理等服务。第三方平台上的商品交易、支付、配送和售后由对应平台负责。
          <a href="/user-agreement">查看完整用户协议</a>
        </p>
      </section>

      <section id="privacy" className="download-legal">
        <h2>隐私政策摘要</h2>
        <p>
          佣值选会在实现账号登录、商品浏览、返利记录、钱包提现、客服反馈和安全风控所必需的范围内处理个人信息。
          我们不会将用户个人信息出售给第三方。用户可通过 App 内设置、客服邮箱或官方联系方式行使查询、更正、删除和注销账号等权利。
          <a href="/privacy">查看完整隐私政策</a>，并可查看<a href="/sdk-list">第三方 SDK 清单</a>和<a href="/account-deletion">账号注销说明</a>。
        </p>
      </section>

      <footer className="download-footer">
        <div>
          <strong>{companyName}</strong>
          <p>客服邮箱：<a href={`mailto:${supportEmail}`}>{supportEmail}</a></p>
          <p className="download-footer__record">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
              <span className="download-footer__record-icon" aria-hidden="true">备</span>
              {icpNumber}
            </a>
          </p>
        </div>
        <nav aria-label="页面导航">
          <a href="/user-agreement">用户协议</a>
          <a href="/privacy">隐私政策</a>
          <a href="/sdk-list">SDK 清单</a>
          <a href="/account-deletion">账号注销</a>
          <a href={apkUrl}>Android 下载</a>
        </nav>
      </footer>
    </main>
  );
}

export default Download;
